import React from 'react';
import * as THREE from 'three';
import { createRoot } from 'react-dom/client';
import { Canvas } from '@react-three/fiber';
import { Cloud, Clouds, OrbitControls, OrthographicCamera, Sky } from '@react-three/drei';
import HexagonBoard from './board/board';
import { Knight } from './characters/knight';
import { SkeletonMage } from './characters/skeleton-mage';
import { SkeletonWarrior } from './characters/skeleton-warrior';
import { Druid } from './characters/druid';
import { Mage } from './characters/mage';
import { CloudBig } from './decorations/cloud-big';
import { SkeletonNecro } from './characters/skeleton-necro';
import { Bloom, EffectComposer, Noise, Pixelation } from '@react-three/postprocessing';
import { WatchTower } from './buildings/watch-tower';
import { Tower } from './buildings/tower';

function App() {
  return (
    <div id="canvas-container">
      <Canvas
        flat
        shadows
        onCreated={({ gl }) => {
          gl.shadowMap.type = THREE.PCFSoftShadowMap;
          gl.outputColorSpace = THREE.SRGBColorSpace;
        }}
        gl={{
          antialias: true,
        }}
        style={{ backgroundColor: '#112233' }}
      >
        {/* Camera */}
        <OrthographicCamera makeDefault position={[7.5, 9, 18]} zoom={150} near={0} />

        {/* Post Processing */}
        <EffectComposer>
          <Pixelation granularity={4} />
          <Bloom luminanceThreshold={0.9} />
        </EffectComposer>

        {/* Light */}
        <directionalLight
          position={[15, 20, 5]}
          intensity={1}
          castShadow
          shadow-mapSize-width={2048} // Increase shadow map resolution (default is 512)
          shadow-mapSize-height={2048}
          shadow-radius={8}
        />
        <hemisphereLight intensity={2} />
        <OrbitControls />

        {/* Decorations */}
        <Clouds material={THREE.MeshBasicMaterial}>
          <Cloud bounds={[20, 3, 20]} position={[26, -7, 0]} volume={4} color="#bbbbbb" speed={0.02} />
          <Cloud bounds={[20, 3, 20]} position={[0, -7, 26]} volume={4} color="#bbbbbb" speed={0.03} />
          <Cloud bounds={[20, 3, 20]} position={[-26, -7, 0]} volume={4} color="#bbbbbb" speed={0.01} />
          <Cloud bounds={[20, 3, 20]} position={[0, -7, -26]} volume={4} color="#bbbbbb" speed={0.032} />
        </Clouds>

        {/* Game board */}
        <HexagonBoard />
        <CloudBig />

        {/* Buildings */}
        <WatchTower />
        <Tower />

        {/* Characters */}
        <Knight />
        <Druid />
        <Mage />

        <SkeletonMage />
        <SkeletonWarrior />
        <SkeletonNecro />
      </Canvas>
    </div>
  );
}

const root = document.getElementById('react-root');
if (!root) {
  throw new Error('React root element not found');
}

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
